(() => {
  const openDialog = () => document.querySelector('[data-gift-dialog][open]');

  // Klicks abfangen, bevor das Theme reagiert (Drawer bleibt offen)
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-gift-dialog-open], [data-savings-dialog-open]');
    if (opener) {
      event.preventDefault();
      event.stopPropagation();
      const scope = opener.hasAttribute('data-savings-dialog-open')
        ? opener.closest('[data-cart-savings]')
        : opener.closest('line-item');
      const dialog = scope?.querySelector('[data-gift-dialog]');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const closer = event.target.closest('[data-gift-dialog-close]');
    if (closer) {
      event.preventDefault();
      event.stopPropagation();
      closer.closest('dialog').close();
      return;
    }

    // Klick auf den abgedunkelten Hintergrund
    if (event.target.matches('[data-gift-dialog]')) {
      event.stopPropagation();
      event.target.close();
    }
  }, true);

  // Esc schließt nur das Pop-up, nicht zusätzlich den Drawer
  document.addEventListener('keydown', event => {
    const dialog = openDialog();
    if (event.key === 'Escape' && dialog) {
      event.preventDefault();
      event.stopPropagation();
      dialog.close();
    }
  }, true);
})();